import { Pipe, PipeTransform } from '@angular/core';

import { AutocompletePlace } from '@shared/base-search-bar/entities/autocomplete';

@Pipe({
  name: 'placeAirports',
  pure: false,
  standalone: false
})

export class PlaceAirportsPipe implements PipeTransform {

  transform(city: AutocompletePlace, airports: AutocompletePlace[] = []): AutocompletePlace[] {
    return airports.filter(airport => airport.related_city === city.related_city &&
      airport.country === city.country);
  }

}
